import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs, validationSchemaEnded } from '../constants';
import { toast } from 'react-toastify';
import FormMunicipalityEnded, {
  MunicipalityEndedForm,
} from 'system/geographic/components/municipality/ended';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { transformRequestMunicipalityEnded } from 'system/geographic/utils/transformer-municipality-ended';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const MunicipalityEndedNewPage = (): React.ReactElement => {
  const insertMunicipalityEnded = useHttpClient(`${__MUNICIPALITY_API_URL__}/geo/comune/cessato`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: MunicipalityEndedForm | undefined) => {
      const data = transformRequestMunicipalityEnded(formValues);
      (
        insertMunicipalityEnded({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/comune');
      });
    },
    [insertMunicipalityEnded, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Nuovo Comune Soppresso' }]} />
      <FormMunicipalityEnded
        title="Nuovo Comune Soppresso"
        onOk={onSubmit}
        validationSchema={validationSchemaEnded}
        isForeign
        onCancel={() => {
          navigate('/sistema/geografiche/comune');
        }}
      />
    </Fragment>
  );
};

MunicipalityEndedNewPage.displayName = 'Municipality new ended page component';

export default MunicipalityEndedNewPage;
